import http from './api'

const route = 'app/comercial/analiseprodutos5/'

export default {
  showAnalise5Faturamento: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, categoria, promotor, classificacao, linhasProducao, produtos, cidades) => {
    return http.post(route + 'showAnalise5Faturamento', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhasProducao: linhasProducao,
      produtos: produtos,
      cidades: cidades,
    })
  },

  showAnalise5ProdutoDevolucao: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, categoria, promotor, classificacao, linhasProducao, produtos, cidades) => {
    return http.post(route + 'showAnalise5ProdutoDevolucao', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhasProducao: linhasProducao,
      produtos: produtos,
      cidades: cidades,
    })
  },

  showAnaliseProdutosLitrosFaturados: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, categoria, promotor, classificacao, linhasProducao, produtos, cidades) => {
    return http.post(route + 'showAnaliseProdutosLitrosFaturados', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhasProducao: linhasProducao,
      produtos: produtos,
      cidades: cidades,
    })
  },

  showAnaliseProduto5FatClassificacao: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, categoria, promotor, classificacao, linhasProducao, produtos, cidades) => {
    return http.post(route + 'showAnaliseProduto5FatClassificacao', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhasProducao: linhasProducao,
      produtos: produtos,
      cidades: cidades,
    })
  },

  showGraficoFaturamentoLitrosGrupo: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, categoria, promotor, classificacao, linhasProducao, produtos, cidades) => {
    return http.post(route + 'showGraficoFaturamentoLitrosGrupo', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhasProducao: linhasProducao,
      produtos: produtos,
      cidades: cidades,
    })
  },

  showGraficoLitrosFaturamentoPrecoMedioGrupo: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, categoria, promotor, classificacao, linhasProducao, produtos, cidades) => {
    return http.post(route + 'showGraficoLitrosFaturamentoPrecoMedioGrupo', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhasProducao: linhasProducao,
      produtos: produtos,
      cidades: cidades,
    })
  },

  showAnaliseFaturamentoLitrosGrupoProdutos: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, categoria, promotor, classificacao, produtos, cidades, linhasProducao) => {
    return http.post(route + 'showAnaliseFaturamentoLitrosGrupoProdutos', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhasProducao: linhasProducao,
      produtos: produtos,
      cidades: cidades,
    })
  },

  showFaturamentoLitrosGrupoMes: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, categoria, promotor, classificacao, linhasProducao, produtos, cidades) => {
    return http.post(route + 'showFaturamentoLitrosGrupoMes', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhasProducao: linhasProducao,
      produtos: produtos,
      cidades: cidades,
    })
  },

  showAnaliseCompartivoFaturamentoLitrosMes: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, categoria, promotor, classificacao, linhasProducao, produtos, cidades) => {
    return http.post(route + 'showAnaliseCompartivoFaturamentoLitrosMes', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhasProducao: linhasProducao,
      produtos: produtos,
      cidades: cidades,
    })
  },

  showAnaliseProduto5DevolucaoLinha: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, categoria, promotor, classificacao, linhasProducao, produtos, cidades) => {
    return http.post(route + 'showAnaliseProduto5DevolucaoLinha', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhasProducao: linhasProducao,
      produtos: produtos,
      cidades: cidades,
    })
  },

  showDadosMixComercializado: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, categoria, promotor, classificacao, produtos, cidades, linhasProducao) => {
    return http.post(route + 'showDadosMixComercializado', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhasProducao: linhasProducao,
      produtos: produtos,
      cidades: cidades,
    })
  },

  showDadosNaoComercializado: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, categoria, promotor, classificacao, produtos, cidades, linhasProducao) => {
    return http.post(route + 'showDadosNaoComercializado', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhasProducao: linhasProducao,
      produtos: produtos,
      cidades: cidades,
    })
  },

  showAnalise5ProdutosNaoComercializados: (dataInicial, dataFinal, empresa, vendedor, area, redes, supervisor, classificacao, linhasProducao, cidades, tokencontrato) => {
    return http.post(route + 'showAnalise5ProdutosNaoComercializados', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: empresa,
      vendedor: vendedor,
      area: area,
      rede: redes,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      classificacao: classificacao,
      linhasProducao: linhasProducao,
      cidades: cidades,
    })
  },

  showFaturamentoVolumeGrupoMes: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, categoria, promotor, classificacao, produtos, cidades, linhasProducao) => {
    return http.post(route + 'showFaturamentoVolumeGrupoMes', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhasProducao: linhasProducao,
      produtos: produtos,
      cidades: cidades,
    })
  },
}
